import axios from "axios"
import { IToolSupportParams } from "../models/managerModels"
import { paramsConfig } from "../../utils/paramsUtils"
import { localStorageItem } from "../../utils/localStorage"
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts"

const API_HRM_URL = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"] || process.env.REACT_APP_API_URL
const API_CHAM_CONG_URL = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["hrmTimekeeping"] || process.env.REACT_APP_API_URL_CHAM_CONG
const API_V1_URL = API_HRM_URL + "/api/v1"

export const reloadCategoryValue = () => {
  return axios.get(API_HRM_URL + "/c-simple-category-attribute-value/reload-config");
}

export const reloadUser = () => {
  return axios.get(API_HRM_URL + "/users/cache/reload");
}

export const reloadDepartment = () => {
  return axios.get(API_HRM_URL + "/c-department/reload");
}

export const reloadOrganization = () => {
  return axios.get(API_HRM_URL + "/organizations/reload");
}

export const updateEmployeeInfo = (option: string | number | null) => {
  return axios.get(API_V1_URL + `/tool/employee/update-data?option=${option}`);
}

export const createAccountDefault = () => {
  return axios.get(API_V1_URL + "/tool/account/create-by-employees");
}

export const reloadAttribution = () => {
  return axios.get(API_CHAM_CONG_URL + "/workday-type/reload");
}

export const generateOfficeWork = (searchParams: IToolSupportParams) => {
  return axios.get(API_CHAM_CONG_URL + "/work-schedule/tool/create", paramsConfig(searchParams));
}

export const generateTimesheet = (searchParams: IToolSupportParams) => {
  return axios.get(API_CHAM_CONG_URL + "/general-timesheet/gen", paramsConfig(searchParams));
}

export const reloadMappingSymbol = () => {
  return axios.get(API_CHAM_CONG_URL + "/mapping-ma-cong-viec/reload");
}

export const reloadSymbol = () => {
  return axios.get(API_CHAM_CONG_URL + "/ma-cong-viec/reload");
}